import { render, staticRenderFns } from "./TableCom.vue?vue&type=template&id=568cad03"
import script from "./TableCom.vue?vue&type=script&lang=js"
export * from "./TableCom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports